import React, { SyntheticEvent } from 'react';
import cn from 'clsx';

import Button from '../../../../library/button/button';
import Typography from '../../../../library/typography/typography';
import { TagsSolidIcon } from '../../../../shared/icons/icons';
import ProductPromoCountdown from '../../../product-promo-countdown/product-promo-countdown';
import PromotionBrandLogo from '../promotion-brand-logo/promotion-brand-logo';

import { useModal } from '../../../../shared/hooks/hooks';

import { getFormatedRebateDatesWithTimeZoneOffset } from '../../../../shared/utils/cart/cart';
import { getPromoCountdownText } from '../../../../shared/utils/product/product';

import { SIGN_IN_MODAL } from '../../../../shared/constants/modals';

import styles from './product-promo.scss';

interface ProductPromoProps {
  brand?: string;
  className?: string;
  description: string;
  endDate?: string | null;
  hideCountdown?: boolean;
  isLoggedIn: boolean;
  isTreadwellPromo: boolean;
  onClick?: (e: SyntheticEvent) => void;
  onSignIn?: () => void;
  productType?: string;
  shortDescription?: string;
  showDuration?: boolean;
  showSignInLink?: boolean;
  showTooltip?: boolean;
  startDate?: string | null;
  url?: string;
}

function ProductPromo(props: ProductPromoProps) {
  const {
    brand,
    className,
    description = '',
    endDate,
    hideCountdown = false,
    isLoggedIn,
    isTreadwellPromo,
    onClick,
    onSignIn,
    productType,
    shortDescription,
    showDuration,
    showSignInLink,
    showTooltip,
    startDate,
    url
  } = props;

  const { openModal } = useModal();

  const { formattedEndDate, formattedStartDate } =
    getFormatedRebateDatesWithTimeZoneOffset(startDate, endDate);

  const countdownText = getPromoCountdownText(endDate);

  let subtitle;
  if (brand && productType) {
    subtitle = () => (
      <PromotionBrandLogo brand={brand} productType={productType} />
    );
  }

  return (
    <div className={cn(styles['container'], className)}>
      <TagsSolidIcon className={styles['icon']} />
      <span className={styles['messasge-container']}>
        <span className={styles['messages']}>
          <span
            className={styles['promo-text']}
            dangerouslySetInnerHTML={{ __html: description }}
          />
          {showSignInLink && (
            <Button
              onClick={() => {
                openModal(SIGN_IN_MODAL, {
                  heading: shortDescription,
                  onSignIn,
                  shouldUseHashRouter: false,
                  subtitle: subtitle
                });
              }}
              size="regular"
            >
              &nbsp;Sign in
            </Button>
          )}
          {url && !showSignInLink && !isTreadwellPromo && (
            <Button href={url} onClick={onClick} size="regular" target="_blank">
              &nbsp;learn more
            </Button>
          )}
          {isLoggedIn && isTreadwellPromo && (
            <Typography className={styles['discount']} tag="span">
              Discount will be applied to cart
            </Typography>
          )}
          {showDuration && startDate && endDate && (
            <Typography className={styles['duration']} tag="span">
              &nbsp;- Valid {formattedStartDate} - {formattedEndDate}
            </Typography>
          )}
          &nbsp;&nbsp;&nbsp;
        </span>

        {!hideCountdown && countdownText && (
          <ProductPromoCountdown
            countdownText={countdownText}
            showTooltip={showTooltip}
          />
        )}
      </span>
    </div>
  );
}

export default ProductPromo;
